// /frontend/src/services/api/presence.js
import api from '@/services/api';

export const presenceApi = {
  out(payload) {
    // payload: { studentId, occurredAt?, reasonId?, note? }
    return api.post('/presence/out', payload);
    },
  in(payload) {
    // payload: { studentId, occurredAt?, note? }
    return api.post('/presence/in', payload);
  },
  getReasons() {
    // aktive Entlassungsgründe aus der DB (table release_reason)
    return api.get('/attendance/reasons');
  }
};
